import { Component, computed, inject, input } from '@angular/core';
import type { OnyxTime } from '@onyx/angular';
import {
  OnyxDatePipe,
  OnyxMapRoutePointStatus,
  OnyxTimePipe,
  OnyxWidgetBoxComponent,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import { DictionaryCode } from '../../../../common/enums/dictionary-code';
import { CommonHelper } from '../../../../common/helpers/common.helper';
import { RouteHelper } from '../../../../common/helpers/route.helper';
import { OrderStatus } from '../../common/enums/order-status';
import { OrderHelper } from '../../common/helpers/order.helper';
import type { Order } from '../../common/interfaces/order';
import { OrderModalFinishedSectionMainWidgetComponent } from './order-modal-finished-section-main-widget/order-modal-finished-section-main-widget.component';
import { OrderModalOutstandingPaymentComponent } from './order-modal-outstanding-payment/order-modal-outstanding-payment.component';

@Component({
  selector: 'app-order-modal-statuses',
  imports: [
    OnyxDatePipe,
    OnyxTimePipe,
    OnyxWidgetBoxComponent,
    OrderModalFinishedSectionMainWidgetComponent,
    OrderModalOutstandingPaymentComponent,
  ],
  templateUrl: './order-modal-statuses.component.html',
  styleUrl: './order-modal-statuses.component.scss',
})
export class OrderModalStatusesComponent {
  private readonly commonHelper = inject(CommonHelper);

  public readonly order = input.required<Order>();
  public readonly close$ = input.required<Subject<void>>();

  protected readonly I18N = 'orders.orderModal';

  protected readonly OnyxMapRoutePointStatus = OnyxMapRoutePointStatus;
  protected readonly OrderStatus = OrderStatus;
  protected readonly OrderHelper = OrderHelper;
  protected readonly DictionaryCode = DictionaryCode;

  protected hasApprovedVehicle = computed(() =>
    OrderHelper.hasApprovedVehicle(this.order().status.value),
  );
  protected isOrderFinished = computed(() =>
    OrderHelper.isFinished(this.order().status.value),
  );
  protected isArchived = computed(() =>
    OrderHelper.isArchived(this.order().status.value),
  );
  protected isInactive = computed(() =>
    OrderHelper.isInactive(this.order().status.value),
  );
  protected currentPoint = computed(() =>
    OrderHelper.getCurrentPoint(this.order().points),
  );
  protected pointData = computed(() =>
    RouteHelper.getPointRouteData(
      this.currentPoint(),
      this.order().points,
      this.commonHelper.nowMinute(),
    ),
  );
  protected finishedOrderData = computed(() => {
    const finishedOrder = this.order().timestamps.completingDocumentsAt;
    if (!finishedOrder) return null;

    const [date, time] = finishedOrder.split('T');
    return { date, time: time as OnyxTime };
  });
  protected missingAssignment = computed(() =>
    OrderHelper.getMissingAssignment(this.order()),
  );
}
